export default "__VITE_PUBLIC_ASSET__70a83d8a__"